(ns manage.content-variant-page.entities.tagging-tracker-ocp.macro-input
  (:require [common.trie :as trie]
            [lemonpi.content-function.shared.macro :as shared.macro]
            [manage.slate-editor.macro-input :as macro-input]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$]]))

(rf/reg-sub ::macro-dictionary
  :<- [:config]
  (fn [{:keys [taggingHints]} _]
    (trie/build-trie taggingHints #{\. \:})))

(defn macro-input
  [props]
  (let [dictionary @(rf/subscribe [::macro-dictionary])
        macro-set (-> @(rf/subscribe [:config]) :taggingHints set)]
    ($ macro-input/macro-input (assoc props
                                      :get-auto-complete-options (fn [macro-content-text]
                                                                   (trie/prefix-matches macro-content-text dictionary))
                                      :is-macro-valid? (fn [macro-content-text]
                                                         (or (some? (shared.macro/parse-macro (str "${" macro-content-text "}")))
                                                             (contains? macro-set macro-content-text)))))))
